import { useState } from 'react'
import { NavLink, Outlet } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import { useMarketShellScrollLock } from '../hooks/useMarketShellScrollLock'
import { useSidebarCollapsed } from '../hooks/useSidebarCollapsed'
import { NavIcon } from './NavIcon'
import { IconLogout } from './icons/CatalogActionIcons'
import { MenuIcon } from './icons/MenuIcon'
import {
  IconChevronLeft,
  IconChevronRight,
  IconSidebarCollapse,
  IconSidebarExpand,
} from './icons/SidebarCollapseIcon'

export const OperatorShell = () => {
  useMarketShellScrollLock()
  const { session, logout } = useAuth()
  const { collapsed, toggleCollapsed } = useSidebarCollapsed()
  const [navOpen, setNavOpen] = useState(false)
  const displayName = session?.email ?? ''

  const shellClass = [
    'market-shell',
    navOpen ? 'market-shell--nav-open' : '',
    collapsed ? 'market-shell--sidebar-collapsed' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={shellClass}>
      {navOpen ? (
        <button
          type="button"
          className="market-shell__backdrop"
          aria-label="Закрыть меню"
          onClick={() => setNavOpen(false)}
        />
      ) : null}
      <button
        type="button"
        className="market-shell__mobile-toggle"
        aria-label="Меню"
        aria-expanded={navOpen}
        onClick={() => setNavOpen((open) => !open)}
      >
        <MenuIcon />
      </button>
      <aside className="market-shell__sidebar" aria-label="Кабинет оператора">
        <div className="market-shell__brand">
          <span className="market-shell__logo" title="Провизиум">
            {collapsed ? 'П' : 'Провизиум'}
          </span>
          {!collapsed ? <span className="market-shell__subtitle">Кабинет оператора</span> : null}
        </div>

        <nav id="market-shell-sidebar-nav" className="market-shell__nav">
          <NavLink
            to="/operator"
            end
            title="Поставщики"
            aria-label="Поставщики"
            onClick={() => setNavOpen(false)}
            className={({ isActive }) =>
              isActive ? 'market-shell__link market-shell__link--active' : 'market-shell__link'
            }
          >
            <NavIcon name="suppliers" />
            <span className="market-shell__link-label">Поставщики</span>
          </NavLink>
          <NavLink
            to="/operator/buyers"
            title="Рестораны"
            aria-label="Рестораны"
            onClick={() => setNavOpen(false)}
            className={({ isActive }) =>
              isActive ? 'market-shell__link market-shell__link--active' : 'market-shell__link'
            }
          >
            <NavIcon name="customers" />
            <span className="market-shell__link-label">Рестораны</span>
          </NavLink>
        </nav>

        <div className="market-shell__user">
          {!collapsed ? <p className="market-shell__user-name">{displayName}</p> : null}
          <button
            type="button"
            className="market-shell__collapse-toggle"
            aria-label={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
            aria-expanded={!collapsed}
            aria-controls="market-shell-sidebar-nav"
            title={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
            onClick={toggleCollapsed}
          >
            {collapsed ? <IconSidebarExpand /> : <IconSidebarCollapse />}
            <span className="market-shell__collapse-toggle-label">
              {collapsed ? 'Развернуть' : 'Свернуть'}
            </span>
          </button>
          {!collapsed ? (
            <button type="button" className="echat-btn echat-btn--ghost" onClick={logout}>
              Выйти
            </button>
          ) : (
            <button
              type="button"
              className="echat-btn echat-btn--ghost market-shell__icon-only-btn"
              onClick={logout}
              title="Выйти"
              aria-label="Выйти"
            >
              <IconLogout />
            </button>
          )}
        </div>

        <button
          type="button"
          className="market-shell__edge-toggle"
          aria-label={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
          aria-expanded={!collapsed}
          aria-controls="market-shell-sidebar-nav"
          title={collapsed ? 'Развернуть меню' : 'Свернуть меню'}
          onClick={toggleCollapsed}
        >
          {collapsed ? <IconChevronRight /> : <IconChevronLeft />}
        </button>
      </aside>

      <main className="market-shell__main">
        <Outlet />
      </main>
    </div>
  )
}
